import React from "react";
import { getUrlDocument } from "../../../../stores/utils/utilities";
import classes from './Items.css';

const Pdfs = props => (
<li className={["list-group-item", classes.list_group, classes.list_item,classes.row_video].join(' ')} onClick={props.onItemSelected}>
    <div className={["row"].join(" ")}>
      <div className={["col-12 sin_padding", classes.videoContainer].join(" ")}>
        <div className={classes.thumbanil}>
          <img src={getUrlDocument(props.item.imagen_portada)} alt={props.titulo}/>
        </div>
      </div>
      <div className={["col-12 sin_padding", classes.textoVideoContainer].join(" ")}>

          <div className={[" sin_padding", classes.contenedorTitulo].join(" ")}>
          <span className={[classes.titulo_video, "color_blanco"].join(" ")}>{props.item.titulo}</span>
          </div>

      </div>
    </div>
  </li>
);

export default Pdfs;
